
import { ReactNode } from 'react';

export interface FormSectionProps {
  title: string;
  children: ReactNode;
  description?: string;
  htmlFor?: string;
  error?: string;
}

export function FormSection({ title, children, description, htmlFor, error }: FormSectionProps) {
  return (
    <div className="space-y-2">
      <div className="space-y-1">
        <label htmlFor={htmlFor} className="font-medium text-sm">
          {title}
        </label>
        {description && <p className="text-sm text-muted-foreground">{description}</p>}
        {error && <p className="text-sm text-destructive">{error}</p>}
      </div>
      {children}
    </div>
  );
}
